import React from 'react';
import { Headphones, FileText, Moon, Heart, CheckCircle, Clock, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
const inclusions = [{
  icon: Headphones,
  text: 'Audiolibro completo (60 min) — escúchalo mientras haces tu rutina'
}, {
  icon: Moon,
  text: 'Protocolo de Oscuridad — prepara tu entorno para el descanso real'
}, {
  icon: FileText,
  text: 'Guía PDF con rituales de temperatura y horarios exactos'
}, {
  icon: Heart,
  text: 'Bonus: Meditación "Regreso al Sueño" para el despertar de las 3 AM'
}];
export function WhatYouGet() {
  return <section className="py-14 px-4" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-center text-gold-400 mb-3" data-id="element-171">
            ¿Qué es exactamente El Protocolo de Sueño Profundo?
          </h2>
          <p className="text-center text-warmWhite-200 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-172">
            Es un sistema completo basado en cronobiología que te enseña a
            reprogramar tu cuerpo para dormir profundamente — sin pastillas, sin
            equipos costosos, y adaptado a los cambios hormonales después de los
            50.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-173">
          {/* Product Image */}
          <FadeIn data-id="element-174">
            <div className="relative flex justify-center" data-id="element-175">
              <motion.img src="https://cdn.magicpatterns.com/uploads/4owiy5ZH57VXpy3W9zDt4S/heylloyd-image-1772256751058.png" alt="El Protocolo de Sueño Profundo" className="w-full max-w-sm rounded-2xl drop-shadow-[0_15px_40px_rgba(0,0,0,0.4)]" animate={{
              y: [0, -8, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-176" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2/3 h-2/3 bg-gold-500/15 rounded-full blur-[50px] -z-10" data-id="element-177" />
            </div>
          </FadeIn>

          {/* Explanation + Inclusions */}
          <FadeIn delay={0.15} data-id="element-178">
            <div className="space-y-6" data-id="element-179">
              {/* Key benefits */}
              <div className="glass-card rounded-2xl p-5 border-l-4 border-l-gold-400/60" data-id="element-180">
                <div className="flex items-center gap-3 mb-3" data-id="element-181">
                  <Sparkles className="w-5 h-5 text-gold-400" data-id="element-182" />
                  <h3 className="text-lg font-heading font-bold text-warmWhite-100" data-id="element-183">
                    En pocas palabras:
                  </h3>
                </div>
                <p className="text-warmWhite-200 leading-relaxed" data-id="element-184">
                  Aprenderás a usar{' '}
                  <span className="text-gold-400 font-medium" data-id="element-185">
                    temperatura, luz y rituales nocturnos
                  </span>{' '}
                  para que tu cerebro produzca melatonina natural y baje el
                  cortisol — logrando que te duermas más rápido, sin
                  despertares, y amanezcas con energía real.
                </p>
              </div>

              {/* What's included */}
              <div data-id="element-186"></div>

              {/* Quick stat */}
              <div className="flex items-center gap-3 pt-2" data-id="element-187">
                <Clock className="w-5 h-5 text-lavender-400" data-id="element-188" />
                <p className="text-sm text-warmWhite-200/70" data-id="element-189">
                  Empieza esta misma noche — resultados visibles en 7 días
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}